module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABQElEQVR42u3asWoCQRSF4QU7H8LWgARsU1rapM4TSMgTiIUp0gkB8Q0C6UOwXlII2giiWBhCBNEuvYLNDWdACRjBhQTcvf/AgeXObLEfztxdMDKzyHMiAAAAAAAAAAAAAAAAcA4QXdzaX+YtXz7rAAAAAMkBLq8fQk5Zm4KRHKDZ6Ya4BZi8r0JcAuinvxunbIPUAxSr9xYPZjacLkLmy6/9nbre1bVGazN5CBYqDesNP44Sak5rMt0FcqU7az/FBw+vmuZctMH648sBgGpu3gP6o8/w0K/xOERDNRddQHt8vdlarfm8r+latWP7P1MAVzetX0951TTn6kUoSdwD8DUIAADpAjB/AwAAfgKc+5799zMAAACcA9AFAKANcggCAABtkC4AAG2QQxAAr12Af4oCAAAAAAAAAAAAAACAn3wD41jHh18NELUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Liberia.png
// module id = epK6
// module chunks = 0 62 63